import { Anchor, Users, Bed, Bath, LifeBuoy, Wifi, Tv, Waves } from "lucide-react";
import { Link } from "react-router-dom";
import { IMAGES } from "../lib/data";

const SPECS = [
  { icon: Users, label: "Capacity 10", sub: "up to 8 for hourly charters" },
  { icon: Bed, label: "3 Bedrooms", sub: "Sleeps 6 comfortably" },
  { icon: Bath, label: "1 Bathroom", sub: "Fresh-water shower" },
  { icon: LifeBuoy, label: "Life Vests", sub: "All sizes onboard" },
  { icon: Waves, label: "Pool Noodles", sub: "For swim stops & drifts" },
  { icon: Wifi, label: "Wifi", sub: "Stay lightly connected" },
  { icon: Tv, label: "TV", sub: "Movie night at anchor" },
  { icon: Anchor, label: "35ft Bavaria", sub: "Meticulously kept" },
];

export default function About() {
  return (
    <div data-testid="about-page" className="bg-sand">
      <section className="pt-28 pb-20 max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="overline mb-5">About</div>
        <h1 className="font-serif-display font-light text-5xl md:text-6xl lg:text-7xl text-navy leading-[1.02] max-w-4xl fade-up">
          Meet the boat — a 35ft Bavaria, kept like a love letter.
        </h1>
        <p className="mt-8 text-[color:var(--am-muted)] max-w-2xl leading-relaxed fade-up fade-up-delay-1">
          She's a bluewater sailor, sharp on the turns, soft on the bones. Three
          quiet cabins below, a wide sunny deck above, and just enough room for
          ten. Anchor Management is a privately-owned charter — that means the
          day is yours, not a schedule's.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-24 grid lg:grid-cols-2 gap-12 items-stretch">
        <div className="img-zoom aspect-[4/5] overflow-hidden">
          <img src={IMAGES.interior} alt="Bavaria sailboat interior" className="w-full h-full object-cover" />
        </div>
        <div className="flex flex-col justify-center">
          <div className="overline mb-4">On Board</div>
          <h2 className="font-serif-display text-4xl lg:text-5xl text-navy leading-tight">
            Everything you'd hope for.<br />Nothing you wouldn't.
          </h2>
          <div className="hairline my-10" />
          <div className="grid grid-cols-2 gap-8">
            {SPECS.map((s, i) => (
              <div key={i} className="flex items-start gap-3" data-testid={`about-spec-${i}`}>
                <s.icon size={20} strokeWidth={1.4} className="text-navy mt-1" />
                <div>
                  <div className="font-serif-display text-xl text-navy leading-tight">{s.label}</div>
                  <div className="text-xs tracking-[0.18em] uppercase text-[color:var(--am-muted)] mt-1">{s.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-navy text-white py-24">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="overline text-white/70 mb-4">The Captain's Promise</div>
            <h2 className="font-serif-display text-4xl lg:text-5xl leading-tight">A slower kind of day.</h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 space-y-5 text-white/80 leading-relaxed">
            <p>
              No megayacht pretense, no rushed anchors, no upselling. Anchor
              Management is a private, family-run operation — just one boat,
              one captain, and a standard we don't bend.
            </p>
            <p>
              You'll be met at the dock with cold towels and a cooler already
              stocked. Where we sail, what we pour, where we stop — it's your
              day. We just make sure it feels like a week.
            </p>
            <Link to="/book" className="btn-primary bg-white text-navy border-white hover:bg-[color:var(--am-pink)] mt-4" data-testid="about-book-button">
              Plan Your Day
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
